import { auth } from '../firebase';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';

// Only this email is allowed to log in as admin
const ADMIN_EMAIL = 'support@dutiap.com';

/**
 * Sign in with email and password
 * @param {string} email - Admin email
 * @param {string} password - Admin password
 * @returns {Promise} Firebase user credential
 */
export const loginWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    
    // Check if the logged in user has the admin email
    if (userCredential.user.email !== ADMIN_EMAIL) {
      // If not admin, sign out and throw error
      await signOut(auth);
      throw new Error('Unauthorized: Not an admin account');
    }
    
    return userCredential.user;
  } catch (error) {
    throw error;
  }
};

/**
 * Sign out current user
 * @returns {Promise} Void promise
 */
export const logout = async () => {
  return signOut(auth);
};

/**
 * Get current user
 * @returns {Object|null} Firebase user object or null if not logged in
 */
export const getCurrentUser = () => {
  return auth.currentUser;
};
